import { z } from "zod";

const websiteRegex =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;

export const uploadArtworkFormSchema = z.object({
  title: z.string().min(1, "Title is required"),
  videoUploaded: z.literal(true, {
    errorMap: () => ({ message: "Please upload your media." }),
  }),
  firstName: z.string().optional(),
  lastName: z.string().min(1, "Last Name is required"),
  isArtist: z.boolean().optional(),
  markedAsMature: z.boolean().optional(),
  allowedWallpaper: z.boolean().optional(),
  createdYear: z.number().min(1, "Year is required"),
  editionPrice: z.number().min(4, "Price is required"),
  numberOfEditions: z.number().min(1, "Edition is required"),
  artMedium: z.string().min(1, "Art Medium is required"),
  artDescription: z.string().optional(),
  subjectAndStyle: z.array(z.string()).min(1, "Subject and Style is required"),
  websiteAddress: z
    .union([
      z.string().regex(websiteRegex, { message: "Invalid URL format" }),
      z.literal(""),
    ])
    .optional(),
  tags: z
    .array(
      z.object({
        id: z.string().min(1),
        text: z.string().min(1),
        className: z.string().optional(),
      })
    )
    .optional(),
});
